module.exports = __webpack_public_path__ + "img/Hunter-tauren-f-70.fd2dff4a.gif";